module.exports = __webpack_public_path__ + "static/img/4.d97242d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/4.png
// module id = 3R8S
// module chunks = 0